import { makeStyles, Theme } from '@material-ui/core';

export const useStyles = makeStyles((theme: Theme) => ({
  previewFooter: {
    display: 'flex',
    gap: '8px',
    position: 'fixed',
    bottom: '0',
    padding: '1rem 2rem',
    background: theme.palette.background.paper,
    width: 'calc(100% - 220px)'
  }
}));
